export class ViewPassword extends HTMLElement {
	/** @type {HTMLButtonElement} */
	button;
	/** @type {HTMLInputElement} */
	input;

	connectedCallback() {
		this.button = this.querySelector("button");
		this.input = this.querySelector("input");
		this.button.addEventListener("click", this.handleClick);
	}

	disconnectedCallback() {
		this.button.removeEventListener("click", this.handleClick);
	}

	handleClick = () => {
		if (this.button.classList.contains("active")) {
			this.button.classList.remove("active");
			this.input.setAttribute("type", "password");
		} else {
			this.button.classList.add("active");
			this.input.setAttribute("type", "text");
		}
	};
}

if (!customElements.get("view-password")) {
	customElements.define("view-password", ViewPassword);
}
